import { Alert } from '@designsforhealth/dfh-react-components'
import React from 'react'

import { useGetCustomerOrder } from '../../../../../lib/orders/hooks/useGetCustomerOrder'
import ContactSupportMessage from '../../../../ContactSupportMessage'
import Spinner from '../../../../Spinner'
import QueryFallback from '../../QueryFallback'
import OrderPageContent from './OrderPageContent'

const CustomerOrderPage: React.VFC<{ orderId: string }> = ({ orderId }) => {
  const { data, error, loading, refetch } = useGetCustomerOrder({ orderId })

  const order = data?.getCustomerOrder

  if (loading) {
    return <Spinner loading />
  }

  return (
    <>
      {!!error && (
        <QueryFallback buttonText="Retry Loading Order" error={error} onRetry={() => refetch()} />
      )}
      {!error && !order && (
        <Alert type="attention">
          Requested order details not found. <ContactSupportMessage />
        </Alert>
      )}
      {!!order && <OrderPageContent order={order} urlFragment={'orders'} />}
    </>
  )
}

export default CustomerOrderPage
